var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteProcedure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8486",
    "data-name": "Group 8486",
    transform: "translate(-1686.428 -3663.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8484",
    "data-name": "Group 8484",
    transform: "translate(1686.066 3663.191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 20,
    height: 20,
    transform: "translate(0.362 0.362)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M1762.789,3675.735a.1.1,0,0,0-.069-.042l-2.57-.406v15.9a1.159,1.159,0,0,1-1.158,1.158h-1.876l2.9.458a.1.1,0,0,0,.12-.088l2.669-16.907A.1.1,0,0,0,1762.789,3675.735Z",
    transform: "translate(-57.289 -9.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8485",
    "data-name": "Group 8485",
    transform: "translate(1689.71 3664.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M1716.875,3668.485h-11.888a.105.105,0,0,0-.105.105v17.117a.105.105,0,0,0,.105.105h11.888a.105.105,0,0,0,.105-.105V3668.59A.105.105,0,0,0,1716.875,3668.485Zm-7.765,1.168h3.7a.5.5,0,0,1,0,1.008h-3.7a.5.5,0,1,1,0-1.008Zm-1.9,1.537h7.5a.5.5,0,1,1,0,1.009h-7.5a.5.5,0,1,1,0-1.009Zm-.376,2.45h6.693a.5.5,0,1,1,0,1.009h-6.693a.5.5,0,1,1,0-1.009Zm0,2.116h8.251a.5.5,0,0,1,0,1.009h-8.251a.5.5,0,1,1,0-1.009Zm0,2.116h4.476a.5.5,0,1,1,0,1.009h-4.476a.5.5,0,1,1,0-1.009Zm2.944,5.266a.72.72,0,0,0-.062.085.958.958,0,0,0,0,.107.589.589,0,0,1-.511.7.763.763,0,0,0-.105.035c-.009.009-.039.055-.059.085a.7.7,0,0,1-.357.318.5.5,0,0,1-.155.024.9.9,0,0,1-.311-.07.667.667,0,0,0-.111-.035.736.736,0,0,0-.109.035.588.588,0,0,1-.823-.272.756.756,0,0,0-.064-.088c-.012-.006-.066-.021-.1-.031a.59.59,0,0,1-.511-.7.669.669,0,0,0,0-.114c-.005-.01-.038-.052-.06-.079a.6.6,0,0,1,0-.883.661.661,0,0,0,.062-.085.9.9,0,0,0,0-.107.59.59,0,0,1,.512-.7.728.728,0,0,0,.105-.034c.009-.009.039-.055.06-.085a.588.588,0,0,1,.823-.272.693.693,0,0,0,.111.035.76.76,0,0,0,.109-.035.69.69,0,0,1,.466-.047.7.7,0,0,1,.357.318.741.741,0,0,0,.064.088c.011.006.065.021.1.031a.59.59,0,0,1,.511.7.691.691,0,0,0,0,.113c.005.011.039.052.061.08a.6.6,0,0,1,0,.883Zm.983.213a.3.3,0,0,1,.164-.4c.139-.057.348-.154.58-.278a.594.594,0,0,1-.083-.133c-.284-.621.614-1.52.87-1.727.393-.317.8-.391,1.072-.192.158.117.381.418.1,1.117a1.677,1.677,0,0,1-.3.471.624.624,0,0,1,.333.087.632.632,0,0,1,.539-.324.531.531,0,0,1,.431.34c.03.061.055.109.076.146a1.537,1.537,0,0,1,.249-.143.8.8,0,0,0,.415-.392.3.3,0,0,1,.573.194,1.371,1.371,0,0,1-.738.749,1.118,1.118,0,0,0-.222.139.481.481,0,0,1-.418.133c-.192-.044-.3-.206-.431-.466-.046.06-.1.131-.134.188-.213.308-.455.656-.822.671h-.025a.356.356,0,0,1-.352-.207c-.081-.186.017-.337.148-.478l-.121.021a3.028,3.028,0,0,1-.366.047,7.943,7.943,0,0,1-1.137.593A.3.3,0,0,1,1710.761,3683.35Zm4.848,1.133h-4.383a.3.3,0,0,1,0-.6h4.383a.3.3,0,0,1,0,.6Z",
    transform: "translate(-1704.882 -3668.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M1741.617,3734.918a2.13,2.13,0,0,0,.791-.8.882.882,0,0,0,.091-.4.7.7,0,0,0-.32.167c-.377.3-.737.857-.7,1.006h0A.59.59,0,0,0,1741.617,3734.918Z",
    transform: "translate(-1734.389 -3721.087)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteProcedure);
export default __webpack_public_path__ + "static/media/white_procedure.44258564ca9dde08ae7677bfbd06b4a0.svg";
export { ForwardRef as ReactComponent };